<template>
  <div id="app">
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Footer from './components/Footer'

export default {
  components: {
    AppFooter: Footer
  }
}
</script>

<style>
  body .Masthead__image.is-parallax > img {
    object-position: bottom;
  }

  body h2, body h3 {
    font-family: 'Alegreya SC', serif;
    text-align: center;
    margin: 0;
  }

  .line-wrapper {
    text-align: center;
    margin-bottom: 1.5rem;
    line-height: 0;
    padding: 0;
  }

  .line {
    border-top: 1px solid #ccc;
    width: 150px;
    display: inline-block;
  }

  body .container {
    padding-top: 15px;
  }

  body .card-title {
    margin-bottom: 0;
    font-size: 1.1rem;
  }

  body .list-group hr {
    margin: 0.5rem -0.5rem;

  }
</style>
